module.exports = __webpack_public_path__ + "static/img/refresh-loading.706106c5.gif";